import { useRef, useEffect } from 'react';

interface TodoEditTextProps {
  initialValue: string;
  onSave: (value: string) => void;
}

export default function TodoEditText({ initialValue, onSave }: TodoEditTextProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);

  return (
    <input
      ref={ref}
      type="text"
      defaultValue={initialValue}
      onBlur={(e) => onSave((e.target as HTMLInputElement).value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onSave((e.target as HTMLInputElement).value);
        }
      }}
      className="flex-1 px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
    />
  );
}
